<template>
  <div>
    <div class="serviceMap">
      <div ref="locusMap" style="height: 740px;"></div>
      <div class="position">
        <div class="positionCard">
          <div class="positionCardTitle el-row--flex is-align-middle">
            <span>轨迹查询</span>
          </div>
          <div class="positionCardContent">
            <div class="el-row--flex is-align-middle">
              定位时间：<span>{{time}}</span>
            </div>
            <div class="el-row--flex is-align-middle">
              <div style="min-width: 60px;">速度：</div>
              <el-slider v-model="speed" :min="1"></el-slider>
              <span style="margin-left: 15px;">{{ speed }}</span>
            </div>
          </div>
          <div class="positionCardContent positionCardBtn el-row--flex is-align-middle">
            <el-button size="small" :type="(playStatus == 0 || playStatus == 1 ? 'primary' : 'danger')"
              @click="playChange">{{playStatus == 0 ? '播放' : playStatus == 1 ? '继续' : '暂停'}}</el-button>
          </div>
        </div>
      </div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-form :inline="true" size="mini">
            <el-input v-model="plateNumber" size="mini" placeholder="请输入车牌号"></el-input>
            <el-input v-model="vin" size="mini" placeholder="请输入车架号"></el-input>
            <el-select v-model="plateColor" placeholder="请选择车牌颜色" size="mini">
              <el-option label="蓝色" value="1"></el-option>
              <el-option label="黄色" value="2"></el-option>
              <el-option label="黄绿色" value="3"></el-option>
            </el-select>
            <el-date-picker size="mini" v-model="beginTime" type="datetime" placeholder="请输入开始时间">
            </el-date-picker>
            <el-date-picker size="mini" v-model="endTime" type="datetime" placeholder="请输入结束时间">
            </el-date-picker>
            <el-button size="small" type="primary" @click="search">查询</el-button>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  import AMapLoader from '@amap/amap-jsapi-loader';

  window._AMapSecurityConfig = {
    serviceHost: location.protocol + '//www.cywy56.com/_GuanWangMapService'
  };

  export default {
    data() {
      return {
        center: [120.268663, 30.202519],
        plateNumber: '',
        plateColor: '2',
        vin:'',
        beginTime: '',
        endTime: '',
        time: '',
        speed: 10,
        playStatus: 0,
        path: [],
        lastTime: '',
        passedLine: null,
        map: null,
        car: null,
      }
    },
    async mounted() {
      AMapLoader.load({
        'key': 'e5f3708364a5fc621433f7819929b056',
        'version': '2.0',
        'plugins': ['AMap.Geolocation', 'AMap.MoveAnimation', 'AMap.ToolBar', 'Amap.Geocoder']
      }).then((AMap) => {
        new AMap.Geolocation().getCurrentPosition((status, res) => {
          if (status == 'complete') {
            this.center = [res.position.lng, res.position.lat];
          }
        })
        // 渲染地图
        let option = {
          resizeEnable: true, // 监控地图容器尺寸变化
          zoom: 12, // 初缩放级别
          center: this.center // 初始中心点
        };
        if (this.mapStyle) {
          option.mapStyle = this.mapStyle;
        } else if (this.darkMode) {
          option.mapStyle = 'amap://styles/dark';
        }
        this.map = new AMap.Map(this.$refs.locusMap, option);
        this.map.addControl(new AMap.ToolBar())
      })
    },
    methods: {
      plateNumberPress(e) {
        let arr = e.replace(/\n/g, '').split('');
        if (arr.length % 8 == 1 && arr.length != 1 && arr[arr.length - 1] != '\n') {
          for (let i = Math.floor(arr.length / 8); i > 0; i--) {
            arr.splice(i * 8, 0, '\n');
          }
          this.plateNumber = arr.join('');
        }
      },
      search() {
        let flag = true;
        if (!
          /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-Za-z]{1}[A-Za-z0-9]{4}[A-Za-z0-9]{1}|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-Za-z]{1}[A-Za-z0-9]{4}[A-Za-z0-9]{2}$/g
          .test(this.plateNumber)) {
          flag = false;
        } else if (this.beginTime == '') {
          flag = false;
        } else if (this.endTime == '') {
          flag = false;
        }
        if (flag) {
          this.$global.axios.post(this, '/sywl/api/locus/searchLocusList', {
            plateNumber: this.plateNumber,
            plateColor: this.plateColor,
                   vin: this.vin,
            beginTime: this.$global.format(this.beginTime, 'yyyy-MM-dd hh:mm:ss'),
            endTime: this.$global.format(this.endTime, 'yyyy-MM-dd hh:mm:ss')
          }, res1 => {
            this.$global.goPay(this, res1.data, res => {
              if (res.data.length != 0) {
                this.path = [];
                let arr1 = new Array();
                res.data.forEach(ele => {
                  arr1.push([ele.lon, ele.lat]);
                })
                this.$global.convertMultiple({
                  AMap: AMap,
                  data: arr1,
                  handle: res1 => {
                    this.map.clearMap();
                    this.path = res1
                    this.path.forEach((ele, index) => {
                      ele.time = res.data[index].gtm
                      ele.speed = res.data[index].spd
                      ele.address = res.data[index].address
                      if (res.data[index].spd !== 0) this.lastTime = ele.time
                    })
                    this.playStatus = 0;
                    // 绘制轨迹
                    new AMap.Polyline({
                      map: this.map,
                      path: this.path,
                      showDir: true,
                      isOutline: true,
                      strokeColor: "#17B583",
                      strokeWeight: 7,
                      borderWeight: 2,
                      outlineColor: '#fff'
                    });
                    this.passedLine = new AMap.Polyline({
                      map: this.map,
                      path: [],
                      showDir: true,
                      isOutline: true,
                      strokeColor: "#1875f0",
                      strokeWeight: 12,
                      borderWeight: 2,
                      outlineColor: '#fff'
                    });
                    new AMap.Marker({
                      map: this.map,
                      position: this.path[0],
                      icon: '/static/images/icon/icon-map-line-start.png',
                      offset: new AMap.Pixel(0, 0)
                    })
                    new AMap.Marker({
                      map: this.map,
                      position: this.path[this.path.length - 1],
                      icon: '/static/images/icon/icon-map-line-end.png',
                      offset: new AMap.Pixel(0, 0)
                    })
                    this.car = new AMap.Marker({
                      map: this.map,
                      position: this.path[0],
                      icon: '/static/images/icon/icon-car.png',
                      offset: new AMap.Pixel(0, 0)
                    })

                    let massArr = new Array();
                    this.path.forEach(ele => {
                      massArr.push({
                        time: ele.time,
                        lnglat: ele
                      })
                    })

                    console.log(massArr)

                    // JSAPI 2.0 支持显示设置 zIndex, zIndex 越大约靠前，默认按顺序排列
                    var style = [{
                      url: '/static/images/icon/icon-mass.png',
                      anchor: new AMap.Pixel(2, 2),
                      size: new AMap.Size(5, 5),
                      zIndex: 3,
                    }];

                    var mass = new AMap.MassMarks(massArr, {
                      opacity: 0.1,
                      zIndex: 111,
                      cursor: 'pointer',
                      style: style
                    });

                    let icon = new AMap.Icon({
                      imageSize: new AMap.Size(12, 12),
                      image: `/static/images/icon/icon-mass0.png`
                    })

                    var massMarker = new AMap.Marker({
                      icon: icon,
                      position: this.path[0],
                      // offset: new AMap.Pixel(-5, -5),
                      anchor: 'center',
                      // content: ' ',
                      map: this.map
                    });
                    massMarker.setLabel({
                      content: '',
                      direction: 'top'
                    })
                    massMarker.setMap(this.map);
                    massMarker.hide();

                    let windowData;

                    mass.on('mouseover', function(e) {
                      windowData = e.data;
                      massMarker.setPosition(e.data.lnglat);
                      massMarker.show();
                    });

                    mass.on('mouseout', function(e) {
                      massMarker.hide();
                      massMarker.setLabel({
                        content: ''
                      })
                    })

                    massMarker.on('click', function(e) {
                      AMap.plugin("AMap.Geocoder", function () {
                        var geocoder = new AMap.Geocoder({});

                        geocoder.getAddress(windowData.lnglat, function (status, result) {
                          //构建信息窗体中显示的内容
                          var info = [];
                          info.push("<p class='input-item'>时间 : " + windowData.time + "</p>");
                          info.push("<p class='input-item'>经纬度 :" + windowData.lnglat.lng + "," + windowData.lnglat.lat + "</p>");

                          if (status === "complete" && result.info === "OK") {
                            // result为对应的地理位置详细信息
                            info.push("<p class='input-item'>位置 :" + result.regeocode.formattedAddress + "</p>");
                          }

                          massMarker.setLabel({
                            content: info.join('')
                          })
                        });
                      });
                    })

                    mass.setMap(this.map);

                    this.map.setFitView()
                  }
                })
              } else {
                this.$message.warning('暂无数据');
              }
            })
          })
        }
      },
      async playChange() {
        if (this.playStatus == 0) {
          this.car.moveAlong(this.path, this.speed * 100);
        } else if (this.playStatus == 2) {
          this.car.pauseMove();
        } else {
          this.car.resumeMove();
        }
        this.car.on('moving', e => {
          this.time = e.passedPath[e.passedPath.length - 1].time ? e.passedPath[e.passedPath.length - 1].time :
            this.time
          this.passedLine.setPath(e.passedPath)
          if (this.time === this.lastTime) this.playStatus = 0;
        })
        this.playStatus = this.playStatus == 0 || this.playStatus == 1 ? 2 : 1;
      }
    },
    watch: {
      speed() {
        this.playStatus = 0;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .serviceMap {
    position: relative;
    width: 100%;
    height: 740px;

    & /deep/ .amap-logo,
    & /deep/ .amap-copyright {
      display: none !important;
    }

    & /deep/ .amap-icon img {
      position: inherit;
    }

    & /deep/ .amap-marker-label {
      padding: 6px 15px;
      border: none;
      border-radius: 3px;
      background-color: rgba($color: #000000, $alpha: .7);
      line-height: 20px;
      color: #fff;
      text-align: left;
    }

    .position {
      position: absolute;
      top: 4px;
      right: 15px;

      &Card {
        width: 280px;
        margin-top: 20px;
        background-color: #fff;

        .el-slider {
          width: calc(100% - 100px);
        }

        &Title {
          height: 37px;
          margin-bottom: 10px;
          padding: 0 14px;
          background: rgba(238, 240, 242, .9);
          border-radius: 2px;
          font-size: 13px;
          color: #000;
        }

        &Content {
          padding: 0 20px;
          font-size: 12px;
        }

        &Btn {
          height: 54px;
        }

        &Td {
          height: 48px;
          padding: 0 23px 0 15px;
          text-align: left;
          font-weight: 500;
          color: #333;
        }

        &Img {
          margin-right: 14px;
        }

        &Number {
          font-size: 13px;
        }

        &Date {
          margin-left: 11px;
          font-size: 12px;
        }

        &Address {
          font-size: 12px;
          font-weight: 400;
          color: #666;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        &Td.active {
          background-color: #1875f0;
          color: #fff;

          .positionCardAddress {
            color: #fff;
          }
        }
      }
    }

    .box-card {
      position: absolute;
      bottom: 10px;
      width: 105%;

      .el-form {
        text-align: left;

        .el-input {
          width: auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/service/locus.vue